export default "__VITE_ASSET__DZQkHnWY__"